import { useTranslation } from 'react-i18next'

import { AgentVerificationApplicationsTable } from '../shared/agentVerificationApplicationsTable'

import { AgentVerificationSimilarProps } from './AgentVerificationSimilar.types'

export function AgentVerificationSimilar({
  isLoadingSimilarApplications,
  similarApplications
}: AgentVerificationSimilarProps) {
  const { t } = useTranslation()

  return (
    <AgentVerificationApplicationsTable
      applications={similarApplications}
      isLoading={isLoadingSimilarApplications}
      heading={t('typography.relatedApplications')}
      getInfoText={count => t('typography.agentSimilarApplications', { count })}
      emptyText={t('typography.noSimilarApplications')}
      testId="agent-verification-similar"
      emptyTestId="agent-verification-empty-similar"
    />
  )
}
